import React from 'react'

export const DashBoardAgencias = () => {
  return (
    <div>DashBoardAgencias</div>
  )
}
